<template>
	<div class="checkbox">
		<label class="crud-label">
			<input
				:id="checkboxData.id"
				type="checkbox"
				:name="checkboxData.name"
				@change="valueIsChanged"
				:checked="checkboxData.value"
			/>
			{{ checkboxData.label }}
			<span class="checkmark">
				<img src="@/drc/assets/images/check.png">
			</span>
		</label>
	</div>
</template>
<script>
	export default {
		name: "InnerCheckbox",
		props: {
			checkboxData: {
				requred: false,
				type: Object
			}
		},
		methods: {
			valueIsChanged() {
				this.$emit("valueHasChanged", {
					fieldName: this.checkboxData.name,
					value: !this.checkboxData.value
				});
			}
		}
	}
</script>
